import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { professionalAction, userActions } from "../../_actions";
import { AppTable } from "../../_components/AppTable";
import {
  Drawer,
  Form,
  Button,
  Col,
  Row,
  Input,
  Select,
  DatePicker,
  Divider,
  PageHeader,
  Descriptions,
  message,
  Modal,
  Spin,
} from "antd";
import { Document6 } from "./ReportDocuments/Document_6";
import { saveAs } from "file-saver";
import { pdf } from "@react-pdf/renderer";
import { adminService } from "../../_services/admin.service";
import { LanguageContext } from "../../context/LanguageContext";
import * as XLSX from "xlsx-js-style";
import moment from "moment";
//import { TableReportSup3 } from "./Tables/TableReportSup3";
const TableReportSup3 = React.lazy(() =>
  import("./Tables/TableReportSup3").then((module) => ({
    default: module.TableReportSup3,
  }))
);

const { RangePicker } = DatePicker;
const { Option } = Select;

class ReportSupReports3 extends React.Component {
  static contextType = LanguageContext;
  constructor(props) {
    super(props);
  }

  state = {
    loading: false,
    downloadLoding: false,
    report_4_startDate: "",
    report_4_endDate: "",
    report4_loader: false,
    report4_List: [],
    report4_List_Total: 0,
    report4_API_loader: false,
    totalCriminal: 0,
  };

  downloadReport1 = async () => {
    const { user } = this.props;
    let obj = {
      startDate: this.state.report_4_startDate,
      endDate: this.state.report_4_endDate,
      cityId: user && user.cityId,
    };
    this.setState({
      report4_loader: true,
    });
    const blob = await pdf(
      <Document6
        rows={this.state.report4_List}
        filterDate={obj}
        allTotal={this.state.totalCriminal}
        total={this.state.report4_List_Total}
      />
    ).toBlob();

    if (blob) {
      this.setState({
        report4_loader: false,
      });
      saveAs(blob, "एकुण आरोपी");
    }
  };
  download_csv = () => {
    const { t } = this.context;
    const report_name = "Accused_Details";
    const file_name = `${report_name}_${moment().format("DDMMMYYYY")}`;
    const ReportTitle = "आरोपीची माहिती";
    const ReportDate = `${moment(this.state.report_4_startDate).format(
      "DD MMM YYYY"
    )}`;

    // ===================== DATA PREPARATION =====================
    const arrData =
      this.state.report4_List?.map((data, index) => ({
        [t("sr.no")]: index + 1,
        घटक: data.policeThane,
        "एकूण आरोपी": data.totalCriminals,
      })) || [];

    if (!arrData.length) return;

    // ===================== STYLES =====================
    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const dateStyle = {
      font: { bold: true, sz: 12 },
      alignment: { horizontal: "center" },
    };

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const cellStyle = {
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    // ===================== WORKBOOK =====================
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet([]);
    const merges = [];
    const headers = Object.keys(arrData[0]);
    const totalCols = headers.length;

    // ===================== TITLE ROW (A1) =====================
    merges.push({ s: { r: 0, c: 0 }, e: { r: 0, c: totalCols - 1 } });
    XLSX.utils.sheet_add_aoa(ws, [[ReportTitle]], { origin: "A1" });
    ws["A1"].s = titleStyle;

    // ===================== DATE ROW (A2) =====================
    merges.push({ s: { r: 1, c: 0 }, e: { r: 1, c: totalCols - 1 } });
    XLSX.utils.sheet_add_aoa(ws, [[ReportDate]], { origin: "A2" });
    ws["A2"].s = dateStyle;

    // ===================== HEADER ROW (A3) =====================
    XLSX.utils.sheet_add_aoa(ws, [headers], { origin: "A3" });

    headers.forEach((_, c) => {
      const cell = XLSX.utils.encode_cell({ r: 2, c });
      if (ws[cell]) ws[cell].s = headerStyle;
    });

    // ===================== DATA ROWS (A4+) =====================
    const ws_data = arrData.map((row) => Object.values(row));
    XLSX.utils.sheet_add_aoa(ws, ws_data, { origin: "A4" });

    ws_data.forEach((row, r) => {
      row.forEach((_, c) => {
        const cell = XLSX.utils.encode_cell({ r: r + 3, c });
        if (ws[cell]) ws[cell].s = cellStyle;
      });
    });

    // ===================== FOOTER =====================
    const footerRowIndex = ws_data.length + 6;
    const footerContent = `Generated At ${moment().format(
      "DD MMM YYYY"
    )} From Criminal Monitoring Intelligent System`;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });

    ws[`A${footerRowIndex}`].s = {
      font: { italic: true, sz: 11, color: { rgb: "555555" } },
      alignment: { horizontal: "center" },
    };

    merges.push({
      s: { r: footerRowIndex - 1, c: 0 },
      e: { r: footerRowIndex - 1, c: totalCols - 1 },
    });

    // ===================== FORMATTING =====================
    ws["!cols"] = headers.map((key) => ({
      wch:
        Math.max(
          key.length,
          ...arrData.map((row) => String(row[key] || "").length)
        ) + 6,
    }));

    ws["!rows"] = [{ hpt: 36 }, { hpt: 24 }, { hpt: 28 }];

    for (let i = 3; i < ws_data.length + 3; i++) {
      ws["!rows"][i] = { hpt: 34 };
    }

    ws["!freeze"] = { ySplit: 3 };
    ws["!merges"] = merges;

    // ===================== EXPORT =====================
    XLSX.utils.book_append_sheet(wb, ws, "Report");
    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };

  generatePDFReport1 = async () => {
    const { user } = this.props;
    let obj = {
      startDate: this.state.report_4_startDate,
      endDate: this.state.report_4_endDate,
      cityId: user && user.cityId,
    };
    this.setState({
      report4_API_loader: true,
    });
    // ggetReports3 hide now
    adminService.totalCrimeList(obj).then((res) => {
      const tempData = res;
      const tempFilterData = _.filter(
        tempData && tempData.data && _.flatten(tempData.data),
        function (o) {
          return Object.keys(o).length !== 0;
        }
      );
      this.setState({
        report4_API_loader: false,
        report4_List: tempFilterData,
        report4_List_Total: tempData && tempData.totalCheckedCriminals,
        totalCriminal: tempData && tempData.allTotalCriminals,
      });
    });
  };

  onFinishDateRangeGPSReport1 = (values) => {
    if (values) {
      this.setState({
        report_4_startDate: values.toISOString(),
      });
    }
  };

  render() {
    const { users } = this.props;
    const { user } = this.props;
    const { professionals } = this.props;
    const { pc_cities, loading } = professionals;

    return (
      <div className="col-md-6 col-md-offset-3">
        <div className="site-page-header-ghost-wrapper">
          <PageHeader
            className="site-page-header"
            ghost={false}
            onBack={false}
            title={user && user.userid}
            subTitle={
              user && user.role === "4" ? "( ADMIN )" : "( SUPER ADMIN )"
            }
          ></PageHeader>
          <PageHeader
            className="site-page-header"
            ghost={false}
            onBack={false}
            title={"आरोपी Report"}
            extra={[
              <Button
                key="1"
                type="primary"
                disabled={!this.state.report4_List.length}
                loading={this.state.report4_loader}
                onClick={this.download_csv}
              >
                Download
              </Button>,
            ]}
          >
            <Descriptions size="small" column={2}>
              <Descriptions.Item label="Select Date">
                <DatePicker
                  style={{ marginRight: 10 }}
                  onChange={(val) => this.onFinishDateRangeGPSReport1(val)}
                  inputReadOnly
                />
                {/* <DatePicker  style={{marginRight:10}} onChange={val => this.onFinishDateRangeGPSReport1(val)} /> */}
                <Button
                  key="1"
                  type="primary"
                  disabled={!this.state.report_4_startDate}
                  loading={this.state.report4_API_loader}
                  onClick={this.generatePDFReport1}
                >
                  Find
                </Button>
              </Descriptions.Item>
            </Descriptions>
          </PageHeader>
          <React.Suspense fallback={<div>Loading...</div>}>
            <TableReportSup3
              data={this.state.report4_List}
              allTotal={this.state.totalCriminal}
              total={this.state.report4_List_Total}
            ></TableReportSup3>
          </React.Suspense>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}

const connectedReports3 = connect(mapStateToProps)(ReportSupReports3);
export { connectedReports3 as ReportSupReports3 };
